export default __webpack_public_path__ + "static/media/weeklyquiz_icon.c00ca420.svg";